module.exports = __webpack_public_path__ + "media/ab-homepage/learn-desktop-6886e6bf.png";